// 判断平台
export function getPlatform () {
  let u = navigator.userAgent
  let versions = {
    /* IE内核 */
    trident: u.indexOf('Trident') > -1,
    /* opera内核 */
    presto: u.indexOf('Presto') > -1,
    // 苹果、谷歌内核
    webKit: u.indexOf('AppleWebKit') > -1,
    // 火狐内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1,
    // 是否为移动终端
    mobile: !!u.match(/AppleWebKit.*Mobile.*/),
    // ios终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    // android终端或者uc浏览器
    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
    // 是否为iPhone或者QQHD浏览器
    iPhone: u.indexOf('iPhone') > -1,
    // 是否iPad 
    iPad: u.indexOf('iPad') > -1,
    // 是否web应该程序，没有头部与底部
    webApp: u.indexOf('Safari') === -1,
    isInApp: u.indexOf('umoocApp') > -1,
    isHarmony: /harmonynextapp/.test(u.toLowerCase())
  }
  return {
    // language: (navigator.browserLanguage || navigator.language).toLowerCase(),
    isMobile: versions.mobile || versions.isInApp,
    isIOS: versions.ios,
    isAndroid: versions.android,
    platform: (versions.mobile || versions.isInApp) ? versions.ios ? 'ios' : 'android' : 'web',
    isInApp: versions.isInApp,
    isHarmony: versions.isHarmony,
    isH5: versions.mobile && !versions.isInApp //h5环境 移动端非app内
  }
}



// WEBPACK FOOTER //
// ./src/common/utils/platform.js